/**
 * 通知公告
 */
angular.module("messageCNoticeModule", [
    "messageCNoticeRouterModule",
    "noticeInfoModule", //公告信息
    "typeConfigAdminModule", //通知公告类型配置-系统管理员
    "typeConfigTAdminModule", //通知公告类型配置-租户管理员
    "noticeServiceModule", // 通知公告服务
]);